var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2231_5535",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 13,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91759 19.2179C4.41588 18.7297 4.41588 17.9383 4.91759 17.4502L12.5738 10.001L4.91759 2.55187C4.41588 2.06373 4.41588 1.27231 4.91759 0.784169C5.4193 0.296033 6.23272 0.296033 6.73443 0.784169L16.2075 10.001L6.73443 19.2179C6.23272 19.706 5.4193 19.706 4.91759 19.2179Z",
    fill: "#006FFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2231_5535)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.374,
    y: 20.002,
    width: 19.9992,
    height: 19.9992,
    transform: "rotate(-180 20.374 20.002)",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftButtonIcon);
export default __webpack_public_path__ + "static/media/left-button-icon.24332564e7cbe7538894f65dc636ab77.svg";
export { ForwardRef as ReactComponent };